import { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSubsidiariesNew, getMainSellers } from '@shared/services/services';
import { orderByName } from '@shared/helpers';

export const usePayeeSelection = ({ forcePointOfSale = false } = {}) => {
  const { user } = useSelector(store => store.userInfo);

  const pageConfiguration = useSelector(store => store.pageConfiguration);
  const { name } = pageConfiguration;

  const entityType = user?.entity?.type?.name;

  const requiresMainSellerSelection =
    entityType === 'Franquicia' || entityType === 'Agencia';

  const isPointOfSale = forcePointOfSale || !requiresMainSellerSelection;

  const [subsidiary, setSubsidiary] = useState(user?.entity ?? null);
  const [seller, setSeller] = useState(null);

  const [subsidiaries, setSubsidiaries] = useState([]);
  const [mainSellers, setMainSellers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isPointOfSale) {
          const { data } = await getSubsidiariesNew({ onlyActive: true });
          setSubsidiaries(orderByName(data));
        } else {
          const sellers = await getMainSellers();
          setMainSellers(sellers);
        }
      } catch (e) {
        console.error('Error cargando payees', e);
      }
    };

    fetchData();
  }, [isPointOfSale]);

  const handleSelectSubsidiary = useCallback(s => {
    setSubsidiary(s);
  }, []);

  const handleSelectSeller = useCallback(s => {
    setSeller(s);
  }, []);

  const displayText = useMemo(() => {
    if (isPointOfSale) {
      return subsidiary
        ? `Agencia seleccionada: ${subsidiary.name}`
        : 'Seleccioná un punto de venta';
    }

    return seller
      ? `Vendedor seleccionado: ${seller.name} ${seller.last_name}`
      : 'Seleccioná tu vendedor de confianza';
  }, [isPointOfSale, subsidiary, seller]);

  return {
    isPointOfSale,
    subsidiaries,
    mainSellers,
    subsidiary,
    seller,
    handleSelectSubsidiary,
    handleSelectSeller,
    displayText,
    name,
  };
};
